<template lang='pug'>
DataProvider(:endpoint='endpoint', :filter='filter' ref='dataProvider')
  div(slot-scope='{ data: response, error, loading }')
    DataTable(
      v-if='response && response.data'
      :data='response && response.data'
      ref='dataTable'
      :title="$t('eventAuthTable.serviceAudit')"
      :customTotal='(response && response.total) || 0'
      @pagination='handlePagination'
      :currentSort.sync='filter.orderBy',
      :currentSortOrder.sync='filter.order',
      :selectable='false'
      :loading='loading'
      customHeader
      :endpoint='endpoint'
      :filter='filter'
      :labels='labels'
      :formatLabelFunction='formatLabels'
      :fileName="$t('eventAuthTable.fileName')"
      :createHeader='createHeaderPDF')
      template(slot='footer' slot-scope='{ pagination }')
        v-row(style='justify-content: flex-end;')
          v-col(cols='auto')
            md-field
              label(for='pages') {{ $t('assistantsList.perPage') }}
              md-select(v-model='pagination.perPage' name='pages' )
                md-option(
                  v-for='item in pagination.perPageOptions',
                  :key='item',
                  :label='item',
                  :value='item')
                  | {{ item }}
      template(slot='cells' slot-scope='{ item }')
        md-table-cell(:md-label='labels[0]' md-sort-by='start_datetime') {{ formatLabels(item, 0) }}
        md-table-cell(:md-label='labels[1]') {{ formatLabels(item, 1) }}
        md-table-cell(:md-label='labels[2]') {{ formatLabels(item, 2) }}
        md-table-cell(:md-label='labels[3]') {{ formatLabels(item, 3) }}
        md-table-cell(:md-label='labels[4]') {{ formatLabels(item, 4) }}
        md-table-cell(:md-label='labels[5]') {{ formatLabels(item, 5) }}
        md-table-cell(:md-label='labels[6]') {{ formatLabels(item, 6) }}
        md-table-cell(:md-label='labels[7]')
            v-btn(color='#4caf50' dark  @click='openConversationDialog(item)' style='float: right;margin-left: 2%') {{$t('eventAuthTable.general')}}
            v-btn(color='#4caf50' dark  @click='openDialog(item)' style='float: right') Chat

        //- md-table-cell(md-label='Última mensagem do usuário') {{ item._source.lastUserMessage }}
    v-dialog(v-model='dialog' max-width='700px' scrollable persistent)
      ChatConversation(
        :chatLoader='chatLoader'
        :chatData='chatData'
        :chatInfo='chatInfo'
        :channelConfig='channelConfig'
        :key='chatInfo._id'
        @close='closeDialog'
      )
    v-dialog(v-model='conversationDialog' scrollable)
        ConversationTimeline(
          :data='conversationData'
          :timelineLoader='conversationChatLoader'
          :userData='userData'
          @close='conversationCloseDialog'
          )
</template>
<script>
import Pagination from '@/components/Pagination.vue'
import eventsList from '@/pages/data/eventsList'
import DateIntervalComponent from '@/components/DateInterval.vue'
import DataTable from '@/components/DataTable.vue'
import DataProvider from '@/components/DataProvider'
import ChatConversation from '@/components/ChatConversation'
import { mapFields } from 'vuex-map-fields'
import { mapGetters } from 'vuex'
import * as moment from 'moment'
import ConversationTimeline from '@/pages/ConversationTimeline.vue'
import { selectedLocale } from '@/plugins/i18n'

export default {
  components: {
    Pagination,
    DateIntervalComponent,
    DataTable,
    ConversationTimeline,
    DataProvider,
    ChatConversation
  },
  data () {
    return {
      labels: [this.$t('eventAuthTable.date'), this.$t('eventAuthTable.protocol'), this.$t('eventAuthTable.channel'), this.$t('eventAuthTable.cpf'), this.$t('eventAuthTable.user'), this.$t('eventAuthTable.row'), this.$t('eventAuthTable.operator'), this.$t('eventAuthTable.events')],
      // searchBarText: undefined,
      dialog: false,
      conversationDialog: false,
      conversationChatLoader: false,
      chatLoader: false,
      showFilter: false,
      // Chat List
      filter: {
        order: 'desc',
        orderBy: 'ts',
        page: 0,
        perPage: null
      },
      tableData: eventsList,
      searchedData: [],
      conversationData: {},
      userData: {},
      chatData: {},
      chatInfo: {},
      channelConfig: null
    }
  },
  computed: {
    ...mapFields('eventAuthHistoryFilter', ['searchBarText', 'dateIntervalFilter', 'protocol', 'user_name', 'cpf', 'group_name', 'operator_name', 'operator_login', 'channelFilter', 'authenticated_type', 'user']),
    ...mapFields('reports', ['dateInterval']),
    ...mapGetters('workspaces', ['active']),
    ...mapGetters('snapshots', ['appliedSnapshot']),
    ...mapFields('selectedAssistant', ['assistantId']),
    endpoint () {
      return `${process.env.VUE_APP_REPORTS_BACKEND}/event-audit`
    },
    hasActiveWorkspace () {
      return this.active ? (this.appliedSnapshot ? 1 : 0) : 0
    }
  },
  mounted () {
    if (typeof this.assistantId !== typeof null) {
      let generalConfig = null
      this.$axios.get(`/assistant-configs/${this.assistantId}`)
        .then(response => {
          generalConfig = response.data
          if (generalConfig.webclientChannels.length > 0) {
            this.channelConfig = generalConfig.webclientChannels[0]
          } else if (generalConfig.whatsappChannels.length > 0) {
            this.channelConfig = generalConfig.whatsappChannels[0]
          } else if (generalConfig.teamsChannels.length > 0) {
            this.channelConfig = generalConfig.teamsChannels[0]
          } else if (generalConfig.telegramChannels.length > 0) {
            this.channelConfig = generalConfig.telegramChannels[0]
          } else {
            this.channelConfig = null
          }
        })
    }
  },
  methods: {
    changeFilters () {
      this.filter.search = this.searchBarText
      this.filter.service_code = this.protocol
      this.filter.user_name = this.user_name
      this.filter.user_id = this.cpf
      this.filter.channel = this.channelFilter
      this.filter.operator_name = this.operator_name
      this.filter.operator_login = this.operator_login
      this.filter.group_name = this.group_name
      this.filter.authenticated_type = this.authenticated_type
      this.filter.user = this.user
      this.filter.start_datetime = this.dateIntervalFilter.timestamp1
      this.filter.end_datetime = this.dateIntervalFilter.timestamp2

      this.$refs.dataProvider.load()
    },
    toggleShowFilter () {
      this.showFilter = !this.showFilter
    },
    endReason (item) {
      if (item._source.closed_by_operator) {
        return this.$t('eventAuthTable.attendant')
      } else if (item._source.closed_by_user) {
        return this.$t('eventAuthTable.user')
      } else if (item._source.expired_by_user_inactivity) {
        return this.$t('eventAuthTable.userInactivity')
      } else {
        return ('-')
      }
    },
    handlePagination (pagination, oldPagination) {
      const newFilter = {}
      const { currentPage, perPage } = pagination
      if (currentPage && this.filter.page !== currentPage - 1) {
        newFilter.page = currentPage - 1
      }
      if (perPage && this.filter.perPage !== perPage) {
        newFilter.perPage = perPage
      }
      Object.assign(this.filter, newFilter)
    },
    async openConversationDialog (item) {
      const conversationId = item._source.conversation_id
      this.conversationDialog = true
      this.conversationChatLoader = true
      this.userData = item
      try {
        const response = await this.$axios.get(`${process.env.VUE_APP_REPORTS_BACKEND}/event-audit/${conversationId}`, {
          params: {
            page: 0,
            perPage: 1000,
            conversationId: conversationId,
            event: 'search-interactions'
          }
        })
        this.conversationData = response.data
      } catch (error) {
        // console.log(error)
      }
      this.conversationChatLoader = false
    },
    async openDialog (item) {
      const conversationId = item._source.conversation_id
      this.dialog = true
      this.chatLoader = true
      try {
        const response = await this.$axios.get(`${process.env.VUE_APP_REPORTS_BACKEND}/interactions`, {
          params: {
            page: 0,
            perPage: 1000,
            conversationId: conversationId,
            event: 'search-interactions'
          }
        })
        this.chatData = response.data
        this.chatInfo = response.data.parent ? response.data.parent : {}
      } catch (error) {
        // console.log(error)
      }
      this.chatLoader = false
    },
    closeDialog () {
      this.dialog = false
    },
    conversationCloseDialog () {
      this.conversationDialog = false
    },
    updatedDate () {
      this.filter.from = this.dateInterval.timestamp1
      this.filter.to = this.dateInterval.timestamp2
      this.$refs.dataProvider.load()
    },
    formatDate (item, type) {
      let date = item._source[type]
      return moment(date).locale(selectedLocale).format('L LT')
    },
    leadZeros (pad, number) {
      return String(number).padStart(pad, '0')
    },
    checkIfFormatDuration (item) {
      return item._source.total_duration ? this.fomartDuration(item._source.total_duration) : '-'
    },
    fomartDuration (duration) {
      let minutes, seconds
      if (duration >= 1) {
        minutes = Math.floor(duration)
      }
      const fractionOfSeconds = Math.ceil(duration) - duration
      seconds = Math.round(fractionOfSeconds * 60)
      return `${minutes ? minutes + 'min' : ''}${seconds ? seconds + 's' : ''}`
    },
    formatDocument (document) {
      if (document) {
      // retira os caracteres indesejados...
        document = document.replace(/[^\d]/g, '')

        // realizar a formatação...
        return document.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
      }
      return '-'
    },

    formatLabels (item, i) {
      switch (i) {
        case 0:
          return this.formatDate(item, 'start_datetime')
        case 1:
          return item._source.service_code ? item._source.service_code : '-'
        case 2:
          return item._source.channel?.length ? item._source.channel[0] : '-'
        case 3:
          return item._source.infos_user ? this.formatDocument(item._source.infos_user.user_id) : '-'
        case 4:
          return item._source.infos_user.user_name ? item._source.infos_user.user_name : '-'
        case 5:
          return item._source.groups?.length > 0 ? item._source.groups[0].name : '-'
        case 6:
          return item._source.operators?.length > 0 ? item._source.operators[0].name : '-'
        case 7:
          return '-'
        default:
          return '-'
      }
    },
    createHeaderPDF (doc, total) {
      doc.setFontSize(14)
      doc.setFont(undefined, undefined, '700')
      doc.text(15, 10, this.$t('eventAuthTable.serviceAudit'))

      doc.setFontSize(10)
      doc.setFont('times', undefined, '700')
      doc.text(15, 17, this.$t('eventAuthTable.timeCourse'))
      doc.setFont('times', undefined, '300')

      let formattedDate1 = moment(this.filter.from).format('DD/MM/YYYY H:mm:ss')
      let formattedDate2 = moment(this.filter.to).format('DD/MM/YYYY H:mm:ss')
      doc.text(29, 17, `${formattedDate1} até ${formattedDate2}`)

      doc.setFont('times', undefined, '700')
      doc.text(15, 22, this.$t('eventAuthTable.totalConversations'))
      doc.setFont(undefined, undefined, '300')
      doc.text(46, 22, `${total}`)

      const tableOffsetY = 30
      return tableOffsetY
    }
  },
  created () {
    this.dateInterval = {
      timestamp1: moment().subtract(1, 'week').startOf('day').format('YYYY-MM-DD[T]HH:mm:ss'),
      timestamp2: moment().endOf('day').format('YYYY-MM-DD[T]HH:mm:ss')
    }
    this.filter.from = this.dateInterval.timestamp1
    this.filter.to = this.dateInterval.timestamp2
  },
  watch: {
    dateInterval: {
      deep: true,
      handler (nV) {
        this.updatedDate()
      }
    }
  }
}
</script>
<style lang='css' scoped>
#custom-filter-input > .v-text-field .v-input__control {
  margin: auto;
}
.v-btn {
  margin: 0.2rem;
  width: 80px;
}
</style>
